import * as Sentry from '@sentry/react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../config/Firebase';
import { chooseDevOrProd, Environment } from '../util/Environment';
import { Log } from '../util/Logging';

export const Errors = {
	initialize() {
		Sentry.init({
			dsn: 'https://6d79874c8d0c466774d04fd91742931f@o4511782872743936.ingest.us.sentry.io/4511782882967552',
			environment: chooseDevOrProd({ development: 'development', production: 'production' }),
			enabled: !Environment.development,
			dataCollection: {
				// To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
				// https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
				// userInfo: false,
				// httpBodies: []
			},
			integrations: [
				Sentry.browserTracingIntegration(),
				Sentry.replayIntegration()
			],
			tracesSampleRate: 1.0,
			replaysSessionSampleRate: 0.1,
			replaysOnErrorSampleRate: 1.0,
			enableLogs: true
		});

		onAuthStateChanged(auth, (authUser) => {
			Sentry.setUser({
				id: authUser?.uid,
				email: authUser?.email ?? undefined,
				username: authUser?.displayName ?? undefined,
			});
		});
	},

	identify(userId: string | undefined) {
		Sentry.setUser({ id: userId });
	},

	report(name: string, error: unknown) {
		Log.system.error(name, error);
		Sentry.captureException(error, { extra: { name } });
	},
};

export async function withErrorAlerts<T>(fallbackMessage: string, f: () => Promise<T>): Promise<T> {
	try {
		return await f();
	} catch (err) {
		alert((err instanceof Error) ? err.message : fallbackMessage);
		throw err;
	}
}
